export type Country = {
    code: string;
    code3: string;
    name: string;
    region: string;
};

// Afghanistan disabled because paysafe will not support cards from this region.
export const CountriesWithISOCodes: Country[] = [
    { code: 'US', code3: 'USA', name: 'United States', region: '1' },
    { code: 'GB', code3: 'GBR', name: 'United Kingdom', region: '44' },
    { code: 'CA', code3: 'CAN', name: 'Canada', region: '1' },
    { code: 'AX', code3: 'ALA', name: 'Åland Islands', region: '358' },
    { code: 'AL', code3: 'ALB', name: 'Albania', region: '355' },
    { code: 'DZ', code3: 'DZA', name: 'Algeria', region: '213' },
    { code: 'AS', code3: 'ASM', name: 'American Samoa', region: '1' },
    { code: 'AD', code3: 'AND', name: 'Andorra', region: '376' },
    { code: 'AO', code3: 'AGO', name: 'Angola', region: '244' },
    { code: 'AI', code3: 'AIA', name: 'Anguilla', region: '1' },
    { code: 'AQ', code3: 'ATA', name: 'Antarctica', region: '672' },
    { code: 'AG', code3: 'ATG', name: 'Antigua and Barbuda', region: '1' },
    { code: 'AR', code3: 'ARG', name: 'Argentina', region: '54' },
    { code: 'AM', code3: 'ARM', name: 'Armenia', region: '374' },
    { code: 'AW', code3: 'ABW', name: 'Aruba', region: '297' },
    { code: 'AU', code3: 'AUS', name: 'Australia', region: '61' },
    { code: 'AT', code3: 'AUT', name: 'Austria', region: '43' },
    { code: 'AZ', code3: 'AZE', name: 'Azerbaijan', region: '994' },
    { code: 'BS', code3: 'BHS', name: 'Bahamas', region: '1' },
    { code: 'BH', code3: 'BHR', name: 'Bahrain', region: '973' },
    { code: 'BD', code3: 'BGD', name: 'Bangladesh', region: '880' },
    { code: 'BB', code3: 'BRB', name: 'Barbados', region: '1' },
    // Belarus disabled because paysafe will not support cards from this region.
    { code: 'BE', code3: 'BEL', name: 'Belgium', region: '32' },
    { code: 'BZ', code3: 'BLZ', name: 'Belize', region: '501' },
    { code: 'BJ', code3: 'BEN', name: 'Benin', region: '229' },
    { code: 'BM', code3: 'BMU', name: 'Bermuda', region: '1' },
    { code: 'BT', code3: 'BTN', name: 'Bhutan', region: '975' },
    { code: 'BO', code3: 'BOL', name: 'Bolivia, Plurinational State of', region: '591' },
    { code: 'BQ', code3: 'BES', name: 'Bonaire, Sint Eustatius and Saba', region: '599' },
    { code: 'BA', code3: 'BIH', name: 'Bosnia and Herzegovina', region: '387' },
    { code: 'BW', code3: 'BWA', name: 'Botswana', region: '267' },
    { code: 'BV', code3: 'BVT', name: 'Bouvet Island', region: '55' },
    { code: 'BR', code3: 'BRA', name: 'Brazil', region: '55' },
    { code: 'IO', code3: 'IOT', name: 'British Indian Ocean Territory', region: '246' },
    { code: 'BN', code3: 'BRN', name: 'Brunei Darussalam', region: '673' },
    { code: 'BG', code3: 'BGR', name: 'Bulgaria', region: '359' },
    { code: 'BF', code3: 'BFA', name: 'Burkina Faso', region: '226' },
    // Burundi disabled because paysafe will not support cards from this region.
    { code: 'KH', code3: 'KHM', name: 'Cambodia', region: '855' },
    { code: 'CM', code3: 'CMR', name: 'Cameroon', region: '237' },
    { code: 'CA', code3: 'CAN', name: 'Canada', region: '1' },
    { code: 'CV', code3: 'CPV', name: 'Cape Verde', region: '238' },
    { code: 'KY', code3: 'CYM', name: 'Cayman Islands', region: '1' },
    { code: 'CF', code3: 'CAF', name: 'Central African Republic', region: '236' },
    { code: 'TD', code3: 'TCD', name: 'Chad', region: '235' },
    { code: 'CL', code3: 'CHL', name: 'Chile', region: '56' },
    { code: 'CN', code3: 'CHN', name: 'China', region: '86' },
    { code: 'CX', code3: 'CXR', name: 'Christmas Island', region: '61' },
    { code: 'CC', code3: 'CCK', name: 'Cocos (Keeling) Islands', region: '61' },
    { code: 'CO', code3: 'COL', name: 'Colombia', region: '57' },
    { code: 'KM', code3: 'COM', name: 'Comoros', region: '269' },
    { code: 'CG', code3: 'COG', name: 'Congo', region: '242' },
    { code: 'CD', code3: 'COD', name: 'Congo, the Democratic Republic of the', region: '243' },
    { code: 'CK', code3: 'COK', name: 'Cook Islands', region: '682' },
    { code: 'CR', code3: 'CRI', name: 'Costa Rica', region: '506' },
    { code: 'CI', code3: 'CIV', name: "Côte d'Ivoire", region: '225' },
    { code: 'HR', code3: 'HRV', name: 'Croatia', region: '385' },
    // Cuba disabled because paysafe will not support cards from this region.
    { code: 'CW', code3: 'CUW', name: 'Curaçao', region: '599' },
    { code: 'CY', code3: 'CYP', name: 'Cyprus', region: '357' },
    { code: 'CZ', code3: 'CZE', name: 'Czech Republic', region: '420' },
    { code: 'DK', code3: 'DNK', name: 'Denmark', region: '45' },
    { code: 'DJ', code3: 'DJI', name: 'Djibouti', region: '253' },
    { code: 'DM', code3: 'DMA', name: 'Dominica', region: '1' },
    { code: 'DO', code3: 'DOM', name: 'Dominican Republic', region: '1' },
    { code: 'EC', code3: 'ECU', name: 'Ecuador', region: '593' },
    { code: 'EG', code3: 'EGY', name: 'Egypt', region: '20' },
    { code: 'SV', code3: 'SLV', name: 'El Salvador', region: '503' },
    { code: 'GQ', code3: 'GNQ', name: 'Equatorial Guinea', region: '240' },
    // Eritrea disabled because paysafe will not support cards from this region.
    { code: 'EE', code3: 'EST', name: 'Estonia', region: '372' },
    { code: 'ET', code3: 'ETH', name: 'Ethiopia', region: '251' },
    { code: 'FK', code3: 'FLK', name: 'Falkland Islands (Malvinas)', region: '500' },
    { code: 'FO', code3: 'FRO', name: 'Faroe Islands', region: '298' },
    { code: 'FJ', code3: 'FJI', name: 'Fiji', region: '679' },
    { code: 'FI', code3: 'FIN', name: 'Finland', region: '358' },
    { code: 'FR', code3: 'FRA', name: 'France', region: '33' },
    { code: 'GF', code3: 'GUF', name: 'French Guiana', region: '594' },
    { code: 'PF', code3: 'PYF', name: 'French Polynesia', region: '689' },
    { code: 'TF', code3: 'ATF', name: 'French Southern Territories', region: '262' },
    { code: 'GA', code3: 'GAB', name: 'Gabon', region: '241' },
    { code: 'GM', code3: 'GMB', name: 'Gambia', region: '220' },
    { code: 'GE', code3: 'GEO', name: 'Georgia', region: '995' },
    { code: 'DE', code3: 'DEU', name: 'Germany', region: '49' },
    { code: 'GH', code3: 'GHA', name: 'Ghana', region: '233' },
    { code: 'GI', code3: 'GIB', name: 'Gibraltar', region: '350' },
    { code: 'GR', code3: 'GRC', name: 'Greece', region: '30' },
    { code: 'GL', code3: 'GRL', name: 'Greenland', region: '299' },
    { code: 'GD', code3: 'GRD', name: 'Grenada', region: '1' },
    { code: 'GP', code3: 'GLP', name: 'Guadeloupe', region: '590' },
    { code: 'GU', code3: 'GUM', name: 'Guam', region: '1' },
    { code: 'GT', code3: 'GTM', name: 'Guatemala', region: '502' },
    { code: 'GG', code3: 'GGY', name: 'Guernsey', region: '44' },
    { code: 'GN', code3: 'GIN', name: 'Guinea', region: '224' },
    { code: 'GW', code3: 'GNB', name: 'Guinea-Bissau', region: '245' },
    { code: 'GY', code3: 'GUY', name: 'Guyana', region: '592' },
    { code: 'HT', code3: 'HTI', name: 'Haiti', region: '509' },
    { code: 'HM', code3: 'HMD', name: 'Heard Island and McDonald Islands', region: '672' },
    { code: 'VA', code3: 'VAT', name: 'Holy See (Vatican City State)', region: '379' },
    { code: 'HN', code3: 'HND', name: 'Honduras', region: '504' },
    { code: 'HK', code3: 'HKG', name: 'Hong Kong', region: '852' },
    { code: 'HU', code3: 'HUN', name: 'Hungary', region: '36' },
    { code: 'IS', code3: 'ISL', name: 'Iceland', region: '354' },
    { code: 'IN', code3: 'IND', name: 'India', region: '91' },
    { code: 'ID', code3: 'IDN', name: 'Indonesia', region: '62' },
    // Iran disabled because paysafe will not support cards from this region.
    // Iraq disabled because paysafe will not support cards from this region.
    { code: 'IE', code3: 'IRL', name: 'Ireland', region: '353' },
    { code: 'IM', code3: 'IMN', name: 'Isle of Man', region: '44' },
    { code: 'IL', code3: 'ISR', name: 'Israel', region: '972' },
    { code: 'IT', code3: 'ITA', name: 'Italy', region: '39' },
    { code: 'JM', code3: 'JAM', name: 'Jamaica', region: '1' },
    { code: 'JP', code3: 'JPN', name: 'Japan', region: '81' },
    { code: 'JE', code3: 'JEY', name: 'Jersey', region: '44' },
    { code: 'JO', code3: 'JOR', name: 'Jordan', region: '962' },
    { code: 'KZ', code3: 'KAZ', name: 'Kazakhstan', region: '7' },
    { code: 'KE', code3: 'KEN', name: 'Kenya', region: '254' },
    { code: 'KI', code3: 'KIR', name: 'Kiribati', region: '686' },
    // North Korea disabled because paysafe will not support cards from this region.
    { code: 'KR', code3: 'KOR', name: 'Korea, Republic of', region: '82' },
    { code: 'KW', code3: 'KWT', name: 'Kuwait', region: '965' },
    // Kyrgyzstan disabled because paysafe will not support cards from this region.
    { code: 'LA', code3: 'LAO', name: "Lao People's Democratic Republic", region: '856' },
    { code: 'LV', code3: 'LVA', name: 'Latvia', region: '371' },
    // Lebanon disabled because paysafe will not support cards from this region.
    { code: 'LS', code3: 'LSO', name: 'Lesotho', region: '266' },
    // Liberia disabled because paysafe will not support cards from this region.
    // Libya disabled because paysafe will not support cards from this region.
    { code: 'LI', code3: 'LIE', name: 'Liechtenstein', region: '423' },
    { code: 'LT', code3: 'LTU', name: 'Lithuania', region: '370' },
    { code: 'LU', code3: 'LUX', name: 'Luxembourg', region: '352' },
    { code: 'MO', code3: 'MAC', name: 'Macao', region: '853' },
    { code: 'MK', code3: 'MKD', name: 'Macedonia, the Former Yugoslav Republic of', region: '389' },
    { code: 'MG', code3: 'MDG', name: 'Madagascar', region: '261' },
    { code: 'MW', code3: 'MWI', name: 'Malawi', region: '265' },
    { code: 'MY', code3: 'MYS', name: 'Malaysia', region: '60' },
    { code: 'MV', code3: 'MDV', name: 'Maldives', region: '960' },
    { code: 'ML', code3: 'MLI', name: 'Mali', region: '223' },
    { code: 'MT', code3: 'MLT', name: 'Malta', region: '356' },
    { code: 'MH', code3: 'MHL', name: 'Marshall Islands', region: '692' },
    { code: 'MQ', code3: 'MTQ', name: 'Martinique', region: '596' },
    { code: 'MR', code3: 'MRT', name: 'Mauritania', region: '222' },
    { code: 'MU', code3: 'MUS', name: 'Mauritius', region: '230' },
    { code: 'YT', code3: 'MYT', name: 'Mayotte', region: '262' },
    { code: 'MX', code3: 'MEX', name: 'Mexico', region: '52' },
    { code: 'FM', code3: 'FSM', name: 'Micronesia, Federated States of', region: '691' },
    { code: 'MD', code3: 'MDA', name: 'Moldova, Republic of', region: '373' },
    { code: 'MC', code3: 'MCO', name: 'Monaco', region: '377' },
    { code: 'MN', code3: 'MNG', name: 'Mongolia', region: '976' },
    { code: 'ME', code3: 'MNE', name: 'Montenegro', region: '382' },
    { code: 'MS', code3: 'MSR', name: 'Montserrat', region: '1' },
    { code: 'MA', code3: 'MAR', name: 'Morocco', region: '212' },
    { code: 'MZ', code3: 'MOZ', name: 'Mozambique', region: '258' },
    { code: 'MM', code3: 'MMR', name: 'Myanmar', region: '95' },
    { code: 'NA', code3: 'NAM', name: 'Namibia', region: '264' },
    { code: 'NR', code3: 'NRU', name: 'Nauru', region: '674' },
    { code: 'NP', code3: 'NPL', name: 'Nepal', region: '977' },
    { code: 'NL', code3: 'NLD', name: 'Netherlands', region: '31' },
    { code: 'NC', code3: 'NCL', name: 'New Caledonia', region: '687' },
    { code: 'NZ', code3: 'NZL', name: 'New Zealand', region: '64' },
    { code: 'NI', code3: 'NIC', name: 'Nicaragua', region: '505' },
    { code: 'NE', code3: 'NER', name: 'Niger', region: '227' },
    { code: 'NG', code3: 'NGA', name: 'Nigeria', region: '234' },
    { code: 'NU', code3: 'NIU', name: 'Niue', region: '683' },
    { code: 'NF', code3: 'NFK', name: 'Norfolk Island', region: '672' },
    { code: 'MP', code3: 'MNP', name: 'Northern Mariana Islands', region: '1' },
    { code: 'NO', code3: 'NOR', name: 'Norway', region: '47' },
    { code: 'OM', code3: 'OMN', name: 'Oman', region: '968' },
    { code: 'PK', code3: 'PAK', name: 'Pakistan', region: '92' },
    { code: 'PW', code3: 'PLW', name: 'Palau', region: '680' },
    // Palestine disabled because paysafe will not support cards from this region.
    { code: 'PA', code3: 'PAN', name: 'Panama', region: '507' },
    { code: 'PG', code3: 'PNG', name: 'Papua New Guinea', region: '675' },
    { code: 'PY', code3: 'PRY', name: 'Paraguay', region: '595' },
    { code: 'PE', code3: 'PER', name: 'Peru', region: '51' },
    { code: 'PH', code3: 'PHL', name: 'Philippines', region: '63' },
    { code: 'PN', code3: 'PCN', name: 'Pitcairn', region: '64' },
    { code: 'PL', code3: 'POL', name: 'Poland', region: '48' },
    { code: 'PT', code3: 'PRT', name: 'Portugal', region: '351' },
    { code: 'PR', code3: 'PRI', name: 'Puerto Rico', region: '1' },
    { code: 'QA', code3: 'QAT', name: 'Qatar', region: '974' },
    { code: 'RE', code3: 'REU', name: 'Réunion', region: '262' },
    { code: 'RO', code3: 'ROU', name: 'Romania', region: '40' },
    { code: 'RU', code3: 'RUS', name: 'Russian Federation', region: '7' },
    { code: 'RW', code3: 'RWA', name: 'Rwanda', region: '250' },
    { code: 'BL', code3: 'BLM', name: 'Saint Barthélemy', region: '590' },
    { code: 'SH', code3: 'SHN', name: 'Saint Helena, Ascension and Tristan da Cunha', region: '290' },
    { code: 'KN', code3: 'KNA', name: 'Saint Kitts and Nevis', region: '1' },
    { code: 'LC', code3: 'LCA', name: 'Saint Lucia', region: '1' },
    { code: 'MF', code3: 'MAF', name: 'Saint Martin (French part)', region: '590' },
    { code: 'PM', code3: 'SPM', name: 'Saint Pierre and Miquelon', region: '508' },
    { code: 'VC', code3: 'VCT', name: 'Saint Vincent and the Grenadines', region: '1' },
    { code: 'WS', code3: 'SWM', name: 'Samoa', region: '685' },
    { code: 'SM', code3: 'SMR', name: 'San Marino', region: '378' },
    { code: 'ST', code3: 'STP', name: 'Sao Tome and Principe', region: '239' },
    { code: 'SA', code3: 'SAU', name: 'Saudi Arabia', region: '966' },
    { code: 'SN', code3: 'SEN', name: 'Senegal', region: '221' },
    { code: 'RS', code3: 'SRB', name: 'Serbia', region: '381' },
    { code: 'SC', code3: 'SYC', name: 'Seychelles', region: '248' },
    { code: 'SL', code3: 'SLE', name: 'Sierra Leone', region: '232' },
    { code: 'SG', code3: 'SGP', name: 'Singapore', region: '65' },
    { code: 'SX', code3: 'SXM', name: 'Sint Maarten (Dutch part)', region: '1' },
    { code: 'SK', code3: 'SVK', name: 'Slovakia', region: '421' },
    { code: 'SI', code3: 'SVN', name: 'Slovenia', region: '386' },
    { code: 'SB', code3: 'SLB', name: 'Solomon Islands', region: '677' },
    // Somalia disabled because paysafe will not support cards from this region.
    { code: 'ZA', code3: 'ZAF', name: 'South Africa', region: '27' },
    { code: 'GS', code3: 'SGS', name: 'South Georgia and the South Sandwich Islands', region: '500' },
    { code: 'SS', code3: 'SSD', name: 'South Sudan', region: '211' },
    { code: 'ES', code3: 'ESP', name: 'Spain', region: '34' },
    { code: 'LK', code3: 'LKR', name: 'Sri Lanka', region: '94' },
    // Sudan disabled because paysafe will not support cards from this region.
    { code: 'SR', code3: 'SUR', name: 'Suriname', region: '597' },
    { code: 'SJ', code3: 'SJM', name: 'Svalbard and Jan Mayen', region: '47' },
    { code: 'SZ', code3: 'SWZ', name: 'Swaziland', region: '268' },
    { code: 'SE', code3: 'SWE', name: 'Sweden', region: '46' },
    { code: 'CH', code3: 'CHE', name: 'Switzerland', region: '41' },
    // Syria disabled because paysafe will not support cards from this region.
    { code: 'TW', code3: 'TWN', name: 'Taiwan', region: '886' },
    { code: 'TJ', code3: 'TJK', name: 'Tajikistan', region: '992' },
    { code: 'TZ', code3: 'TZA', name: 'Tanzania, United Republic of', region: '255' },
    { code: 'TH', code3: 'THA', name: 'Thailand', region: '66' },
    { code: 'TL', code3: 'TLS', name: 'Timor-Leste', region: '670' },
    { code: 'TG', code3: 'TGO', name: 'Togo', region: '228' },
    { code: 'TK', code3: 'TKL', name: 'Tokelau', region: '690' },
    { code: 'TO', code3: 'TON', name: 'Tonga', region: '676' },
    { code: 'TT', code3: 'TTO', name: 'Trinidad and Tobago', region: '1' },
    { code: 'TN', code3: 'TUN', name: 'Tunisia', region: '216' },
    { code: 'TR', code3: 'TUR', name: 'Turkey', region: '90' },
    { code: 'TM', code3: 'TKM', name: 'Turkmenistan', region: '993' },
    { code: 'TC', code3: 'TCA', name: 'Turks and Caicos Islands', region: '1' },
    { code: 'TV', code3: 'TUV', name: 'Tuvalu', region: '688' },
    { code: 'UG', code3: 'UGA', name: 'Uganda', region: '256' },
    { code: 'UA', code3: 'UKR', name: 'Ukraine', region: '380' },
    { code: 'AE', code3: 'ARE', name: 'United Arab Emirates', region: '971' },
    { code: 'GB', code3: 'GBR', name: 'United Kingdom', region: '44' },
    { code: 'US', code3: 'USA', name: 'United States', region: '1' },
    { code: 'UM', code3: 'UMI', name: 'United States Minor Outlying Islands', region: '246' },
    { code: 'UY', code3: 'URY', name: 'Uruguay', region: '598' },
    { code: 'UZ', code3: 'UZB', name: 'Uzbekistan', region: '998' },
    { code: 'VU', code3: 'VUT', name: 'Vanuatu', region: '678' },
    { code: 'VE', code3: 'VEN', name: 'Venezuela, Bolivarian Republic of', region: '58' },
    { code: 'VN', code3: 'VNM', name: 'VietNam', region: '84' },
    { code: 'VG', code3: 'VGB', name: 'Virgin Islands, British', region: '1' },
    { code: 'VI', code3: 'VIR', name: 'Virgin Islands, U.S.', region: '1' },
    { code: 'WF', code3: 'WLF', name: 'Wallis and Futuna', region: '681' },
    { code: 'EH', code3: 'ESH', name: 'Western Sahara', region: '212' },
    { code: 'YE', code3: 'YEM', name: 'Yemen', region: '967' },
    { code: 'ZM', code3: 'ZMB', name: 'Zambia', region: '260' },
    // Zimbabwe disabled because paysafe will not support cards from this region.
];

export const USStatesWithISOCodes = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District Of Columbia' },
    { code: 'FM', name: 'Federated States Of Micronesia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'GU', name: 'Guam' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PW', name: 'Palau' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VI', name: 'Virgin Islands' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
    { code: 'AA', name: 'U.S. Armed Forces – Americas' },
    { code: 'AE', name: 'U.S. Armed Forces – Europe' },
    { code: 'AP', name: 'U.S. Armed Forces – Pacific' },
];

export const USStates = [
    'Alabama',
    'Alaska',
    'American Samoa',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District Of Columbia',
    'Federated States Of Micronesia',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Marshall Islands',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Northern Mariana Islands',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Outside USA',
    'Palau',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virgin Islands',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
];

export const CanadianProvincesWithISOCodes = [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon' },
];
